
import axios from 'axios';
import * as util from 'util';

const api = process.env.REACT_APP_ApiUrl;
const headers = { 'Content-Type': 'application/json' };

export const log = (payload: string) =>
    axios
        .post(`${api}log`, JSON.stringify({ payload }), { headers })
        .catch(() => {});

export const logError = (data: any) => {
    const stackTrace = util.inspect(data);
    axios
        .post(`${api}log`, JSON.stringify({ stackTrace }), { headers })
        .catch(() => {});
};

export const postSettings = (key: string, payload: string) =>
    axios
        .post(`${api}${key}/settings`, payload, { headers })
        .catch(() => {});

export const postPastOrdersInfo = (key: string, payload: string) =>
    axios
        .post(`${api}${key}/total-orders`, payload, { headers })
        .catch(() => {});



// WEBPACK FOOTER //
// ./src/Api/ecommscriptClient.tsx